import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

const VisualCaptcha = ({ onVerify }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [isVerified, setIsVerified] = useState(false);

  const generateNewCaptcha = () => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
    setUserAnswer('');
    setIsVerified(false);
    onVerify(false);
  };

  useEffect(() => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setNum1(num1);
    setNum2(num2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setUserAnswer(value);
    
    const correctAnswer = num1 + num2;
    if (parseInt(value) === correctAnswer) {
      setIsVerified(true);
      onVerify(true);
    } else {
      setIsVerified(false);
      onVerify(false);
    }
  };

  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-gray-700">
        Verificación de Seguridad *
      </label>
      
      <div className="flex items-center gap-2 sm:gap-3">
        {/* Visual Captcha Display */}
        <div className="flex-1 bg-gradient-to-r from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-lg p-2 sm:p-4 flex items-center justify-center gap-1 sm:gap-3">
          <div className="bg-white rounded-lg px-2 py-1.5 sm:px-4 sm:py-2 text-xl sm:text-2xl font-bold text-blue-600 shadow-sm">
            {num1}
          </div>
          <span className="text-xl sm:text-2xl font-bold text-gray-600">+</span>
          <div className="bg-white rounded-lg px-2 py-1.5 sm:px-4 sm:py-2 text-xl sm:text-2xl font-bold text-cyan-600 shadow-sm">
            {num2}
          </div>
          <span className="text-xl sm:text-2xl font-bold text-gray-600">=</span>
          <input
            type="number"
            value={userAnswer}
            onChange={handleInputChange}
            className="w-14 sm:w-20 bg-white rounded-lg px-1 sm:px-4 py-1.5 sm:py-2 text-xl sm:text-2xl font-bold text-center border-2 border-gray-300 focus:border-blue-500 focus:outline-none shadow-sm"
            placeholder="?"
          />
        </div>

        {/* Refresh Button */}
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={generateNewCaptcha}
          className="h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0 hover:bg-blue-50"
          title="Generar nuevo captcha"
        >
          <RefreshCw className="w-4 h-4 sm:w-5 sm:h-5" />
        </Button>
      </div>

      {/* Verification Status */}
      {userAnswer && (
        <div className="flex items-center gap-2">
          {isVerified ? (
            <>
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm text-green-600 font-medium">
                ✓ Verificación correcta
              </span>
            </>
          ) : (
            <>
              <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-sm text-red-600 font-medium">
                ✗ Respuesta incorrecta
              </span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default VisualCaptcha;
